<span class="fa-stack fa" style="cursor: pointer;">
  <i [class]="iClass" [style]="iconStyle"></i>
  <strong class="fa-stack-1x fa-xs mt-4" [class]="textClass" [style]="textStyle">{{text}}</strong>
</span>